import { T } from '@/lib/i18n'

/**
 * Tarix köməkçiləri — «Tezliklə» premyera sətri (MYTasks 528) və yaş qapısının
 * tarix seçicisi (MYTasks 530) eyni ay adlarını işlədir, ona görə siyahı
 * BURADA, tək yerdədir (əvvəl `ui/detailModal.ts`-in içində idi).
 */

/**
 * Ay açarları — `T()`-yə DƏYİŞƏN kimi gedir (`lib/i18n.ts`-dəki qeydə bax:
 * örtük testi bunları tuta bilmir, lüğətdə əl ilə saxlanılır). Siyahı saytdakı
 * `DateSelect.tsx` cədvəli ilə EYNİDİR.
 */
export const MONTH_KEYS = [
  'Yanvar',
  'Fevral',
  'Mart',
  'Aprel',
  'May',
  'İyun',
  'İyul',
  'Avqust',
  'Sentyabr',
  'Oktyabr',
  'Noyabr',
  'Dekabr',
]

/**
 * Bakı vaxtı — sabit +04:00 (Azərbaycan 2016-dan yay vaxtına keçmir). Premyera Bakı
 * təqvimində elan olunur, server isə vaxtı UTC ilə qaytarır.
 */
const BAKU_OFFSET_MINUTES = 4 * 60

/** `yyyy-mm-ddThh:mm[:ss[.fff…]][Z|±hh:mm]` — kəsr rəqəmlərinin sayı məhdud deyil (.NET 7 rəqəm verir). */
const DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?$/

/**
 * Premyera tarixi — «5 Sentyabr 2026» (TAM ay adı ilə, 523/528 müqaviləsi).
 * Mənbə `publishAt || releaseDate` — saytdakı `premiereText` ilə eyni seçim
 * (`publishAt` planlı yayım vaxtıdır və üstündür).
 *
 * ⚠ `Intl.DateTimeFormat` İŞLƏDİLMİR: köhnə TV mühərriklərində lokal məlumatı
 *   etibarsızdır, ay adları isə onsuz da lüğətdədir (`MONTH_KEYS`) — üç səthdə
 *   eyni sözlər çıxır.
 * ⚠ `new Date(iso)` / `Date.parse` İŞLƏDİLMİR: TV-nin saat qurşağı tez-tez səhv qurulur və
 *   köhnə mühərrik .NET-in 7 rəqəmli kəsr saniyəsini oxumur (NaN). Sətir əl ilə parçalanır.
 * ⚠⚠ VAXTLI DƏYƏR BAKIYA ÇEVRİLİR, SONRA GÜN GÖTÜRÜLÜR (2026-10-25). Kodda izlənildi:
 *   tarix ilk 10 simvoldan dilimlə oxunurdu, server isə `publishAt`-ı UTC ilə verir
 *   (`2026-09-04T22:00:00Z` = Bakıda 5 Sentyabr 02:00). ƏVVƏL Bakıda 00:00–03:59 arası
 *   planlanan premyera bir gün ƏVVƏL göstərilirdi («4 Sentyabr»). Sabit +04:00 əlavə
 *   olunur — mühərrikin qurşaq cədvəlinə ehtiyac qalmır. Qurşaqsız vaxt və yalnız
 *   tarix (`releaseDate`) olduğu kimi qalır: onlar artıq təqvim günüdür.
 */
export function formatPremiere(item: {
  publishAt: string | null
  releaseDate: string | null
}): string | null {
  const raw = item.publishAt || item.releaseDate
  if (!raw || raw.length < 10) return null
  const day = bakuCalendarDay(raw)
  if (!day) return null
  return day.day + ' ' + T(MONTH_KEYS[day.month - 1] as string) + ' ' + day.year
}

/** Sətirdəki təqvim günü — vaxt və qurşaq varsa Bakı vaxtına çevrilmiş halda. */
function bakuCalendarDay(raw: string): { year: number; month: number; day: number } | null {
  let year = Number(raw.slice(0, 4))
  let month = Number(raw.slice(5, 7))
  let day = Number(raw.slice(8, 10))
  if (!year || !month || month > 12 || !day || day > 31) return null

  const match = DATE_TIME_PATTERN.exec(raw)
  const zone = match ? match[7] : undefined
  if (!match || !zone) return { year, month, day }

  let offset = 0
  if (zone !== 'Z') {
    const digits = zone.replace(':', '')
    offset = (Number(digits.slice(1, 3)) * 60 + Number(digits.slice(3, 5))) * (digits.charAt(0) === '-' ? -1 : 1)
  }
  const utc = Date.UTC(year, month - 1, day, Number(match[4]), Number(match[5]), Number(match[6] || 0)) - offset * 60000
  const baku = new Date(utc + BAKU_OFFSET_MINUTES * 60000)
  year = baku.getUTCFullYear()
  month = baku.getUTCMonth() + 1
  day = baku.getUTCDate()
  return { year, month, day }
}
